import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import useModal from '../../../../utils/hooks/useModal';

// Icons
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';

// Components
import Button from '../../../atoms/Button/Button';
import RoleCreationEditionForm from '../RoleCreationEditionForm/RoleCreationEditionForm';

function RoleCreation({
  permissions, setRoles,
}) {
  const { t } = useTranslation();

  const { displayModal } = useModal();

  const roleCreationForm = useRef();

  return (
    <Button
      onClick={() => displayModal({
        maxWidth: 455,
        title: t('roles.creation.title'),
        content: (
          <RoleCreationEditionForm
            ref={roleCreationForm}
            permissions={permissions}
            setRoles={setRoles}
          />
        ),
        buttons: [
          {
            label: t('common.cancel'),
            theme: 'inverted',
          },
          {
            label: t('roles.creation.form.submit'),
            onClick: () => roleCreationForm?.current?.submitForm(),
            queryName: 'postRole',
          },
        ],
      })}
    >
      <PlusIcon className="m-r-10" />
      {t('roles.creation.title')}
    </Button>
  );
}

RoleCreation.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  setRoles: PropTypes.func,
};

RoleCreation.defaultProps = {
  permissions: [],
  setRoles: () => {},
};

export default RoleCreation;
